module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAA20lEQVQ4je2PsWrCUBhGzw0haW6spYKRhIJQips4OHVyFuyLqE/gKziKPoXgGxRXkU5uDoWAREhwMNR0S7p6hTvVMd94/u878AsmgynkI8DhKu/yjf5jB10aqyW19ect/s0x5ibkw7pfd6SrOOn6bT6aPa3UjkKsU6Kwc5o632E4NAHpViRPz1WlEPgerdemVlq8BOB5ChNCAEhDu/pHSmkpLaX3jAlkl59MFkWhHCI7Zm+F2qF9iLDiWGHnNAXITDAWyTEZAw/Xha/IwtvrH2lsttR2u1uc5YjZH+AxNq88JJjPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/LangSelector/flag-it.png
// module id = 2273
// module chunks = 1